import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Button,
  Alert,
  Box,
} from '@mui/material';
import axios from '../utils/axiosConfig';
import { showSuccess, showError } from '../utils/errorHandler';

const BACKEND_URL = process.env.REACT_APP_API_URL;

const CATEGORIES = [
  { value: 'bug', label: '不具合報告' },
  { value: 'feature_request', label: '機能要望' },
  { value: 'question', label: '質問' },
  { value: 'other', label: 'その他' },
];

export default function FeedbackDialog({ open, onClose }) {
  const [category, setCategory] = useState('question');
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async () => {
    setError(null);
    if (!subject.trim() || !message.trim()) {
      setError('件名と内容を入力してください。');
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${BACKEND_URL}/feedbacks/`, { category, subject, message });
      showSuccess('フィードバックを送信しました。ありがとうございます。');
      setCategory('question');
      setSubject('');
      setMessage('');
      onClose();
    } catch (err) {
      const detail = err.response?.data?.detail || '送信に失敗しました。';
      setError(detail);
      showError(detail);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setError(null);
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>フィードバック</DialogTitle>
      <DialogContent>
        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, pt: 1 }}>
          <FormControl fullWidth>
            <InputLabel>カテゴリ</InputLabel>
            <Select
              value={category}
              label="カテゴリ"
              onChange={(e) => setCategory(e.target.value)}
            >
              {CATEGORIES.map((c) => (
                <MenuItem key={c.value} value={c.value}>
                  {c.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <TextField
            label="件名"
            fullWidth
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
            inputProps={{ maxLength: 255 }}
          />
          <TextField
            label="内容"
            fullWidth
            multiline
            rows={5}
            value={message}
            onChange={(e) => setMessage(e.target.value)}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>キャンセル</Button>
        <Button variant="contained" onClick={handleSubmit} disabled={loading}>
          {loading ? '送信中...' : '送信'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
